import React, { Suspense, lazy } from "react";
import LazyComponent from "../../LazyComponent/LazyComponent";
import LazyLoad from "react-lazy-load";
import { Helmet } from "react-helmet";
import HomePageHeroSection from "./HomePageHeroSection/HomePageHeroSection";
import AboutSection from "./AboutSection/AboutSection";
import IndustrySection from "./IndustrySection/IndustrySection";
import OurClients from "../../Components/OurClientSection/OurClients";
import OurServiceSection from "./OurServiceSection/OurServiceSection";
import TestimonialSection from "./TestimonialSection/TestimonialSection";
import WhyHirestarSection from "./WhyHirestarSection/WhyHirestarSection";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import BgvTimerComponent from "./BgvTimerComponent/BgvTimerComponent";
// Lazy load the components
// const HomePageHeroSection = lazy(() => import('./HomePageHeroSection/HomePageHeroSection'));
// const AboutSection = lazy(() => import('./AboutSection/AboutSection'));
// const IndustrySection = lazy(() => import('./IndustrySection/IndustrySection'));
// const OurClients = lazy(() => import('./OurClientSection/OurClients'));
// const OurServiceSection = lazy(() => import('./OurServiceSection/OurServiceSection'));
// const WhyHirestarSection = lazy(() => import('./WhyHirestarSection/WhyHirestarSection'));
// const TestimonialSection = lazy(() => import('./TestimonialSection/TestimonialSection'));
// const FaqComponent = lazy(() => import('../../Components/Footer/FaqComponent/FaqComponent'));
// const HelpCard = lazy(() => import('../../Components/Footer/HelpCenterCard/HelpCard'));
// ------------------------- Lazy Load Components --------------------------------------------------//

const jsonLdData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "HireStar.io",
  url: "https://hirestar.io/",
  logo: "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/HeaderAssets/hireStar.svg",
  description:
    "HireStar.io is a leading blockchain-powered background verification company providing employee screening, criminal record checks, education verification, and other BGV services across India.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Hyderabad",
    addressRegion: "Telangana",
    addressCountry: "IN",
    postalCode: "500081",
    streetAddress: "20, Inorbit Mall Rd, Vittal Rao Nagar, Madhapur, Hyderabad",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-9144101303",
    contactType: "customer support",
    areaServed: "IN",
    availableLanguage: ["English"],
    email: "admin@hirestar.io",
  },
  sameAs: [
    "https://www.linkedin.com/company/hirestar.io/posts/?feedView=all",
    "https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09",
    "https://www.facebook.com/hirestario",
    "https://www.instagram.com/hirestar.io/",
  ],
};

const HomePage = () => {
  return (
    <div>
      {/* -----------------------------meta tags----------------------------------------- */}
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Top Background Verification Companies in Hyderabad | HireStar.io
        </title>
        <meta name="robots" content="index, follow" />
        <meta property="og:site_name" content="Hirestar.io" />
        <meta
          name="description"
          content="Fast and Reliable Background Verification Powered by Blockchain and AI , Secure Accurate Employee Screening Solutions for Modern Businesses"
        />
        <meta
          name="keywords"
          content="Background Verification, Employee Screening, HireStar.io Background Verification, Employee Background Verification in Hyderabad, Employee Background Verification in Delhi, Employee Background Verification in Bengaluru, Employee Background Verification in Mumbai, Employee Background Verification in Chennai, Candidate Verification Services, Pan Card Verify"
        />
        <link rel="canonical" href="https://hirestar.io/" />
        <meta
          property="og:title"
          content="Blockchain-powered Employee Verification for Banking Sector | Hirestar.io"
        />
        <meta
          property="og:description"
          content="HireStar.io is one of the top background verification companies in Hyderabad, offering fast, secure, and blockchain-based employee screening solutions."
        />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/icon.jpeg"
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:url" content="https://hirestar.io/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Blockchain-powered Employee Verification for Banking Sector | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Ensure compliance and security in banking with Hirestar.io's blockchain-backed background checks and verification services."
        />
      </Helmet>
      {/* ----------------------------------------------------------------------- */}
      <HomePageHeroSection />
      <BgvTimerComponent />
      <div className="component_spacing">
        <AboutSection />
      </div>
      <IndustrySection />
      <OurClients />
      <OurServiceSection />
      <WhyHirestarSection />
      <TestimonialSection />
      <FaqComponent />
      <div className="relative top-28  left-0 right-0 help_card">
        <HelpCard />
      </div>
      {/* --------------------------------------------------------- */}

      {/* <div> */}
      {/* </div> */}
      {/* <HomePageHeroSection />
      <Suspense fallback={<>loading...</>}>
        <LazyComponent>
          <HomePageHeroSection />
        </LazyComponent>

        <div className="component_spacing">
          <LazyComponent>
            <AboutSection />
          </LazyComponent>
        </div>

        <LazyComponent>
          <IndustrySection />
        </LazyComponent>

        <LazyComponent>
          <OurClients />
        </LazyComponent>

        <LazyComponent>
          <OurServiceSection />
        </LazyComponent>

        <LazyComponent>
          <WhyHirestarSection />
        </LazyComponent>

        <LazyComponent>
          <TestimonialSection />
        </LazyComponent>

        <LazyComponent>
          <FaqComponent />
        </LazyComponent>

        <div className="relative top-28 left-0 right-0 help_card">
          <LazyComponent>
            <HelpCard />
          </LazyComponent>
        </div>
      </Suspense> */}
    </div>
  );
};

export default HomePage;
